module.exports = __webpack_public_path__ + "static/img/read.4be21353.png";